import {notifications} from "@mantine/notifications";
import {createContext, useMemo, ReactNode, useState} from "react";
import LoaderScreen from "../components/Loader/LoaderScreen.tsx";


export interface MessageContextInterface {
    success: (title: string, message?: string) => any,
    error: (title: string, message?: string) => any,
    setLoaderMessage: (message: string) => any,
}
interface MessageProviderProps {
    children: ReactNode,
}

const MessageContext = createContext<MessageContextInterface>({setLoaderMessage: () => {}, success: () => {}, error: () => {}});

const MessageProvider = ({children}: MessageProviderProps) => {
    const [loader, setLoader] = useState<string>('');

    const context = useMemo(() => {
        const success = (title: string, message?: string) => notifications.show({
            title: title,
            message: message,
            color: 'green',
            autoClose: 3000,
        });
        const error = (title: string, message?: string) => notifications.show({
            title: title,
            message: message,
            color: 'red',
            autoClose: 3000,
        });

        return {success, error, setLoaderMessage: setLoader};
    }, []);

    return (
        <MessageContext.Provider value={context}>
            {loader !== '' ? <LoaderScreen message={loader} /> : null}
            {children}
        </MessageContext.Provider>
    )
}

export default MessageContext;
export {MessageProvider};
